import { render } from "./chevron-previous.svg?vue&type=template&id=60e54292"
const script = {}
script.render = render

export default script